import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0300e07b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0300e07b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0300e07b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0300e07b')) {
      api.createRecord('0300e07b', component.options)
    } else {
      api.reload('0300e07b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0300e07b&scoped=true&", function () {
      api.rerender('0300e07b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/famousPerson/dynamicMent/index.vue"
export default component.exports